import { createAsyncThunk } from '@reduxjs/toolkit';
import { API, API_URL } from '../../../config/api';
import axiosService from '../../../services/axiosServicesVisit';

export const getUsersList = createAsyncThunk('users/fetchAll', async ({page,itemsPerPage,filter}) => {
  const params = new URLSearchParams({
    page,
    limit: itemsPerPage,
    filter: filter.search,
  });
  
  if ([0, 1].includes(filter.status)) {
    params.append('status', filter.status);
  }
    const URL = `${API_URL}${API.USERS.GETUSERS}?${params.toString()}`;
    return axiosService
      .get(URL)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);


export const addUser = createAsyncThunk(
  'users/add',
  async (user) => {
    const URL = API_URL + API.USERS.ADDUSER;
    return axiosService
      .post(URL, user)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const deleteUser = createAsyncThunk(
  'users/delete',
  async (userId) => {
    const URL = `${API_URL  + API.USERS.DELETEUSER}/${userId}`;
    return axiosService
      .delete(URL)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const updateUser = createAsyncThunk(
  'users/update',
  async ({ userId, userData }) => {
    const URL = `${API_URL  + API.USERS.UPDATEUSER}/${userId}`;
    return axiosService
      .patch(URL, userData)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);

export const getUserById = createAsyncThunk(
  'users/fetchById',
  async (userId) => {
    const URL = `${API_URL  + API.USERS.GETUSERBYID}/${userId}`;
    return axiosService
      .get(URL)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
);

